import { translate } from '../../../../utils';
import { HeadCell } from '../../../../ui-kit';
import { DeliveryList } from './types';

export const deliveryListsHeadCells: HeadCell<DeliveryList>[] = [
    { id: 'deliveryDateUtc', label: translate('Delivery date') },
    { id: 'supplier', label: translate('Supplier') },
    { id: 'invoiceNumber', label: translate('Invoice number') },
    { id: 'deliveryListItemsCount', label: translate('Items count'), numeric: true },
    { id: 'deliveryListItemsTotalCost', label: translate('Total cost'), align: 'right' },
];

export const DELIVERY_LISTS_ROWS_PER_PAGE = 10;